import { I18nKey } from '../../i18n/types';

/**
 * 根据 ip 获取多语言 key
 */
export const getI18nKeyByIp = (): Promise<I18nKey | null> => {
  // 当前写死 null
  return Promise.resolve(null);
};
